import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class GenieRoiUtidMultiFilter extends Component {
    state = {
        RoiUtidListLists:[],
        RoiUtidListValue: null,
        isUtidLoading: true
    };
    componentDidMount(){
        this.getRoiUtid(this.props.start_date,this.props.end_date);

    }
//     restServiceFilter() {
//         this.setState({
//             RoiUtidListValue: {value: '', label: 'All'},
//         })
//     }
    getRoiUtid(start_date, end_date){
        var RoiUtidListLists=[];
        axios.post(config.get('API_URL')+'/filters/get-genie-roi-utid/',{
                start_date: start_date,
                end_date: end_date,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            console.log(response.data)
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((utid, index) => {
                    RoiUtidListLists.push({value: utid.utid, label: utid.utid})
                });
            }
            this.setState({
                RoiUtidListLists:RoiUtidListLists,
                isUtidLoading: false
            })
        });
    }

    changeRoiUtidList(optionSelected){
        let value='';
        let utidArray = [];
        if(optionSelected.length < 1){
            value = null;
            utidArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                utidArray.push(ids.value)
                var index = this.state.RoiUtidListLists.findIndex(obj => obj.value==ids.value);
                this.state.RoiUtidListLists.move(index,0).join(',');
            });
        }
        this.props.onSelectUtid(optionSelected, utidArray);
        this.setState({
            RoiUtidListValue:optionSelected,
        });

    }
//     changeRoiUtidList(optionSelected){
//         const value = optionSelected === null ? '' : optionSelected.value;
//         this.props.onSelectUtid(optionSelected);
//         this.setState({
//             RoiUtidListValue:optionSelected,
//         });
//     }
    render() {

        return (

            <ReactMultiSelectCheckboxes name="genie_utid"
                isMulti
                value={this.state.RoiUtidListValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={true}
                onChange={this.changeRoiUtidList.bind(this)}
                options={this.state.RoiUtidListLists}
                placeholderButtonLabel="Select [Utid]"
                isLoading={this.state.isUtidLoading}
            />
        );

    }
}
export default GenieRoiUtidMultiFilter;